import React from 'react';
import { Spinner } from 'react-bootstrap';

const normalizeLoadingMessage = (rawMessage) => {
  const fallback = 'Estamos cargando la informacion. Espera un momento...';
  const message = String(rawMessage ?? '').trim();
  if (!message) return fallback;

  const withoutDots = message.replace(/\.{3}\s*$/, '').replace(/\.\s*$/, '');

  if (/^Cargando\s+/i.test(withoutDots)) {
    const target = withoutDots.replace(/^Cargando\s+/i, '').trim().toLowerCase();
    return `Estamos cargando ${target}. Espera un momento...`;
  }

  if (/^Buscando\s+/i.test(withoutDots)) {
    const target = withoutDots.replace(/^Buscando\s+/i, '').trim().toLowerCase();
    return `Estamos buscando ${target}. Espera un momento...`;
  }

  if (/^Iniciando\s+/i.test(withoutDots)) {
    const target = withoutDots.replace(/^Iniciando\s+/i, '').trim().toLowerCase();
    return `Estamos iniciando ${target}. Espera un momento...`;
  }

  return `${withoutDots}. Espera un momento...`;
};

const BigSpinner = ({ message = 'Cargando informacion...', className = '' }) => {
  const normalizedMessage = normalizeLoadingMessage(message);

  return (
    <div className={`big-spinner-wrapper ${className}`.trim()}>
      <div className="big-spinner-card">
        <div className="big-spinner-icon-wrap" aria-hidden="true">
          <Spinner
            animation="border"
            role="status"
            className="big-spinner-icon"
          >
            <span className="sr-only">{normalizedMessage}</span>
          </Spinner>
        </div>
        <span className="big-spinner-message">{normalizedMessage}</span>
      </div>
    </div>
  )
}

export default BigSpinner;